/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JsonSettings } from '../../models/json-settings';

export interface ConfigSettingGetConfig$Params {
  type?: string | null;
  practiceId?: string | null;
}

export function configSettingGetConfig(http: HttpClient, rootUrl: string, params?: ConfigSettingGetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<JsonSettings>> {
  const rb = new RequestBuilder(rootUrl, configSettingGetConfig.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.query('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JsonSettings>;
    })
  );
}

configSettingGetConfig.PATH = '/api/ConfigSetting';
